import Swiper, {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';

class SwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      slider: '.swiper-container',
    };

    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

    this.elements = {
      slider: this.querySelector(this.selectors.slider),
    };

    this.sectionId = this.elements.slider.dataset.id;
    this.elements.sliderCurrent =
      this.selectors.slider + `[data-id="${this.sectionId}"]`;

    this.load();
  }

  load() {
    const next = `.swiper-button-next--${this.sectionId}`;
    const prev = `.swiper-button-prev--${this.sectionId}`;
    const pagination = `.swiper-pagination--${this.sectionId}`;
    const scrollbar = `.swiper-scrollbar--${this.sectionId}`;

    // additional settings
    const gap = +this.getAttribute('data-swiper-gap');
    const gapDesktop = +this.getAttribute('data-swiper-gap-desktop');
    const isFreeMode = +this.getAttribute('data-swiper-freemode');
    const autoplayDelay = +this.getAttribute('data-swiper-autoplay-delay');
    const loopEnabled = this.getAttribute('data-swiper-loop');
    const loopEnabledDesktop = this.getAttribute('data-swiper-loop-desktop');
    const slidesPerView =
      +this.getAttribute('data-swiper-slides-per-view') || 'auto';
    const slidesPerViewDesktop =
      +this.getAttribute('data-swiper-slides-per-view-desktop') || 'auto';

    let autoplay;
    if (autoplayDelay) {
      autoplay = {
        autoplay: {
          delay: autoplayDelay,
          disableOnInteraction: false,
        },
      };
    }

    this.swiper = new Swiper(this.elements.sliderCurrent, {
      slidesPerView: slidesPerView,
      loop: loopEnabled === 'true' ? true : false,
      spaceBetween: gap ? gap : 0,
      watchOverflow: true,

      breakpoints: {
        990: {
          spaceBetween: gapDesktop || gap || 0,
        },
        1360: {
          loop: loopEnabledDesktop === 'true' ? true : false,
          slidesPerView: slidesPerViewDesktop,
        },
      },

      ...autoplay,

      navigation: {
        nextEl: next,
        prevEl: prev,
      },

      scrollbar: {
        el: scrollbar,
        hide: false,
      },

      pagination: {
        el: pagination,
        clickable: true,
      },
      observer: true,
      observeParents: true,
    });

    this.swiper.on('slideChange', (swipe) => {
      this.onChange();
    });
  }

  onChange() {
    // console.log(`🔮 The future is beautiful!`)
  }
}

customElements.define('swiper-component', SwiperComponent);
